import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function ShareFilledIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8.34052 3.75H9.42472C9.98404 3.75 10.4375 4.18528 10.4375 4.72222C10.4375 5.25917 9.98404 5.69445 9.42472 5.69445H8.41199C6.95115 5.69445 5.95739 5.69651 5.21322 5.79256C4.49818 5.88485 4.16699 6.04757 3.94159 6.26396C3.71618 6.48035 3.54668 6.79829 3.45055 7.48473C3.35049 8.19914 3.34834 9.15314 3.34834 10.5556V14.4444C3.34834 15.8469 3.35049 16.8009 3.45055 17.5153C3.54668 18.2017 3.71618 18.5197 3.94159 18.736C4.16699 18.9524 4.49818 19.1152 5.21322 19.2074C5.95739 19.3035 6.95115 19.3056 8.41199 19.3056H12.5018C13.9626 19.3056 14.9564 19.3035 15.7006 19.2074C16.4156 19.1152 16.7468 18.9524 16.9722 18.736C17.2662 18.4538 17.4589 18.0058 17.5282 16.8205C17.5595 16.2844 18.0376 15.8742 18.5961 15.9043C19.1545 15.9344 19.5818 16.3934 19.5505 16.9295C19.4768 18.1902 19.2635 19.2862 18.4044 20.111C17.74 20.7489 16.9101 21.0133 15.9705 21.1345C15.0754 21.2501 13.9446 21.25 12.5732 21.25H8.34055C6.96918 21.25 5.83834 21.2501 4.94333 21.1345C4.00369 21.0133 3.17383 20.7489 2.50937 20.111C1.84491 19.4731 1.56948 18.6764 1.44315 17.7744C1.32282 16.9152 1.32285 15.8296 1.32288 14.5131V10.4869C1.32285 9.17044 1.32282 8.08484 1.44315 7.22563C1.56948 6.32358 1.84491 5.52691 2.50937 4.88903C3.17383 4.25115 4.00369 3.98673 4.94333 3.86546C5.83834 3.74994 6.96916 3.74997 8.34052 3.75Z"
				fill="currentColor"
			/>
			<path
				d="M16.5349 2.75C15.9001 2.75 15.3854 3.24408 15.3854 3.85355V6.25H12.5208C9.21282 6.25 6.53119 8.82436 6.53119 12V14.5C6.53119 14.8561 6.79201 15.1631 7.15536 15.2347C7.51777 15.3061 7.88252 15.1237 8.02939 14.798C8.07154 14.7189 8.19247 14.4939 8.28611 14.3494C8.47409 14.0595 8.76532 13.6708 9.17341 13.283C9.98235 12.5142 11.2451 11.75 13.1157 11.75H15.3854V14.1464C15.3854 14.7559 15.9001 15.25 16.5349 15.25C16.8398 15.25 17.1322 15.1337 17.3478 14.9268L22.08 10.3839C22.4623 10.0169 22.6771 9.51906 22.6771 9C22.6771 8.48094 22.4623 7.98315 22.08 7.61612L17.3478 3.07322C17.1322 2.86627 16.8398 2.75 16.5349 2.75Z"
				fill="currentColor"
			/>
		</svg>
	);
}

ShareFilledIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default ShareFilledIcon;
